import apiSportEvents from '@/api/sports-events'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  data: null
}

export const mutationTypes = {
  updateSportEventStart: '[update sport event] Update sport event start',
  updateSportEventSuccess: '[update sport event] Update sport event success',
  updateSportEventFailure: '[update sport event] Update sport event failure',

  getSportEventStart: '[update sport event] Get sport event start',
  getSportEventSuccess: '[update sport event] Get sport event success',
  getSportEventFailure: '[update sport event] Get sport event failure'
}

export const actionTypes = {
  updateSportEvent: '[update sport event] Update sport event',
  getSportEvent: '[update sport event] Get sport event'
}

const mutations = {
  [mutationTypes.updateSportEventStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.updateSportEventSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateSportEventFailure](state, payload) {
    state.error = payload || 'error'
    state.isSubmitting = false
  },

  [mutationTypes.getSportEventStart](state) {
    state.isLoading = true
    state.data = null
  },

  [mutationTypes.getSportEventSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getSportEventFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.updateSportEvent](context, {sportEventInput}) {
    context.commit(mutationTypes.updateSportEventStart)
    return new Promise(resolve => {
      apiSportEvents
        .updateSportEvent(sportEventInput)
        .then(response => {
          context.commit(mutationTypes.updateSportEventSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.updateSportEventFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getSportEvent](context, {id}) {
    context.commit(mutationTypes.getSportEventStart)
    return new Promise(resolve => {
      apiSportEvents
        .getSportEvent(id)
        .then(response => {
          context.commit(mutationTypes.getSportEventSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getSportEventFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
